import { render, staticRenderFns } from "./UpsellCardsContainer.vue?vue&type=template&id=ecd33646&scoped=true&"
import script from "./UpsellCardsContainer.vue?vue&type=script&lang=js&"
export * from "./UpsellCardsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd33646",
  null
  
)

export default component.exports